<div class="container bg-header modal-add-attachment-header">
  <div class="row align-items-center">
    <div class="col d-flex align-items-center">
      <h1 mat-dialog-title class="text-white m-0">{{(attachmentData.title || 'modals.modal-add-attachment.add-evidences') | translate}}</h1>
    </div>
    <div class="col-auto d-flex align-items-center">
      <button mat-icon-button class="close-toolbar-btn" (click)="closeDialogue()"
        [matTooltip]="'generic.buttons.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  @if (attachmentData.attachmentType == 'PUBMED') {
  <div>
    <app-pubmed-attachment (attachElement)="attachElement($event)"></app-pubmed-attachment>
  </div>
  }
  @if (attachmentData.attachmentType == 'FILE') {
  <div>
    <app-file-attachment [data]="attachmentData" (attachElement)="attachElement($event)"></app-file-attachment>
  </div>
  }
</div>
